import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ReimbursementsList } from "../../components/ReimbursementsList";


export interface IReimbursementsListPage {}

export const ReimbursementsListPage: FC<IReimbursementsListPage> = (
  props: IReimbursementsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Reimbursements List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Reimbursements", navigateTo: "/company/reimbursements/list" },
      ]}
      mainContents={<ReimbursementsList />}
    />
  );
};
